export const DoxFileOperations = {
    VIEW: 'view',
    RENAME: 'rename',
    DELETE: 'delete',
    RECOVER: 'recover',
    DOWNLOAD: 'download'
}

export const DoxFileOperationStatus = {
    IN_PROGRESS: 'in_progress',
    COMPLETE: 'complete',
    FAIL_NO_SUCH_FILE: 'no_such_file',
    FAIL_TRANSIENT: 'transient_error',
    FAIL_FILE_NEEDED: 'file_needed',
    FAIL_DELETE_CLIENT_FILE: 'delete_client_file',
    FAIL_RENAME_CLIENT_FILE: 'rename_client_file',
    FAIL_RENAME_SIGNED_FILE: 'rename_signed_file',
    FAIL_TRY_AGAIN: 'try_again'
}

